
import { compose, mdsWidget } from 'dojo/_base/declare';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import "../../../moreCore/UI/GenericDialog/GenericDialog";
import _EntityViewMixin from '../../../moreCore/UI/EntityBased/EntityView/EntityView';

class MonthColumnPlanGroupView extends compose(_EntityViewMixin<more.EntityAPIResult>) {

    onShow() {
        // zb weitere Buttons zum Dlg oder in den Tab einfügen...
    }


    onDelete() {

    }

    afterDelete() {

    }

    onClose() {


    }

    /**
*
* @param entityId
* @param label
* @param additionalParams
* @param tabContainerName
* @param contextName Beliebiger Kontextname, der im Backend eine Differenzierung zum Zweck der Ansicht zulässt
*/
    setup(entityId: string,
        entityClass: string,
        label: string,
        labelProperty: string,
        destination?: HTMLElement | "dlg" | string,
        additionalParams?: Object,
        contextName?: string) {

        this.config.entityClassname = entityClass;
        this.config.labelProperty = labelProperty;

        if (contextName) this.setContextName(contextName);

        if (additionalParams) this.setAdditionalRequestParameters(additionalParams);

        if (destination === "dlg" || !destination) {
            this.showAsDlg(entityId, label);
        } else if (destination instanceof HTMLElement) {
            this.showAtNode(entityId, label, destination);
        } else if (typeof (destination) == "string") {
            this.showAsTab(entityId, label, destination);
        }
    }


    postCreate(): void {

        this.config = {
            entityClassname: "appointment_draft_group",
            labelProperty: null,
            entityClassPrintname: null
        }
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    public getCurrentDlg(): MdsLax<InstanceType<typeof GenericDialog>> | null {
        if (typeof this.dlg != 'undefined') {
            if (this.dlg != null) {
                return this.dlg;
            }
        }
        return null;
    }

}

export default mdsWidget(MonthColumnPlanGroupView);
